import i18n from 'modules/core/lib/i18n'

export const ALL_TYPES = {
  adherence: 'adherence',
  contract: 'contract',
  custom: 'custom',
  custom_company: 'custom_company',
  custom_company_public: 'custom_company_public',
  default: 'default',
  expenses_company: 'expenses_company',
  expenses_employee: 'expenses_employee',
  hiring: 'hiring',
  id_document: 'id-document',
  modelo_145: 'modelo-145',
  novation: 'novation',
  payment: 'payment',
  payslip: 'payslip',
  es_payslip: 'Nóminas',
  fr_payslip: 'Bulletins de salaires',
  sick_leave: 'sick-leave',
  social_insurance: 'social_insurance',
  tax: 'tax',
  payslip_summary: 'payslip_summary',
  es_payslip_summary: 'Resúmenes de nómina',
  fr_payslip_summary: 'Résumé Paie',
  es_payroll_export: 'Descargas de nómina',
  fr_payroll_export: 'Données sur les salaires',
  readonly: 'readonly',
  readonly_employee: 'readonly_employee',
  payroll_company: 'payroll_company',
  training_certificates: 'training_certificates',
  onboarding: 'onboarding',
}

export type UPLOAD_TYPE = (typeof ALL_UPLOAD_TYPES)[keyof typeof ALL_UPLOAD_TYPES]

export const ALL_UPLOAD_TYPES = {
  split: 'split',
  combine: 'combine',
  do_not_touch: 'do_not_touch',
  manual_per_file: 'manual_per_file',
  manual_per_page: 'manual_per_page',
} as const

export type DISTRIBUTION_WORKFLOWS = 'personal_files' | 'templates' | 'same_files' | 'payslips'

export const ESIGNATURE_FILE_TYPE = 'application/pdf'
export const ESIGNATURE_MAX_FILE_SIZE = 15 * 1000 * 1000
export const MAX_FILE_SIZE = 200 * 1000 * 1000
export const MAX_DAYS_TO_BE_DELETED = 30

export const SPACES = {
  EMPLOYEE_MY_DOCUMENTS: 'employee_my_documents',
  COMPANY_PUBLIC: 'company_public',
  COMPANY_INTERNAL: 'company_internal',
  UNKNOWN: 'unknown',
} as const

export type SPACE = (typeof SPACES)[keyof typeof SPACES]
export const DOCUMENT_SIGNATURE_PENDING = () => i18n.t('documents.signature_status.pending')
export const DOCUMENT_SIGNATURE_PARTIALLY_SIGNED = () =>
  i18n.t('documents.signature_status.partially_signed')
export const DOCUMENT_SIGNATURE_COMPLETED = () => i18n.t('documents.signature_status.completed')
export const DOCUMENT_SIGNATURE_DECLINED = () => i18n.t('documents.signature_status.declined')
export const DOCUMENT_SIGNATURE_BOUNCED_EMAIL = () =>
  i18n.t('documents.signature_status.bounced_email')
export const DOCUMENT_SIGNATURE_CANCELLED = () => i18n.t('documents.signature_status.cancelled')
export const DOCUMENT_SIGNATURE_ERROR = () => i18n.t('documents.signature_status.error')
export const DOCUMENT_SIGNATURE_EXPIRED = () => i18n.t('documents.signature_status.expired')
export const LOCALSTORAGE_DOCUMENTS_SUBFOLDER_COUNT = 'factorial:documentFolderSubfoldersCount'
